<template>
    <div v-if="client.enable_time_sheets">
        <b-link title="Saisie des temps" @click="initModal">
            <strong>T</strong>
        </b-link>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TimeSheetHandler',

    props: {
        client: {},
    },

    data() {
        return {
            form: {},
            formatted_current_date: '',
            fiscalYearOptions: [],
        }
    },

    methods: {
        initModal() {
            this.$store.commit('data/RESET_MODAL_DATA')
            const modalData = {
                client: this.client,
            }
            this.$store.commit('data/SET_MODAL_DATA', modalData)
            this.$bvModal.show('modal-time-sheet')
        },

        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
            this.$store.commit(
                'timeSheetsVM/SET_CURRENT_DATE',
                this.form.current_date
            )
        },
    },

    computed: {
        ...mapState({
            activityDate: (state) => state.timeSheetsVM.currentDate,
            year: (state) => state.browsing.year,
            hasError: (state) => state.timeSheetsVM.hasError,
            errorMessage: (state) => state.timeSheetsVM.errorMessage,
        }),

        disableSubmit() {
            return !parseFloat(this.form.activity_duration) > 0
        },
    },
}
</script>

<style scoped></style>
